import React, { useState } from "react";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/footer";
import { IMAGES } from "../../constant/Image";
import Banner from "../../components/TitleBanner/index";
import { cardData } from "../../constant/fake-data";
import { IoSearchOutline } from "react-icons/io5";
import AuctionSlider from "../../components/Auction_Card/index";
import { TbFilterDown } from "react-icons/tb";

const Auction = () => {
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedPeriod, setSelectedPeriod] = useState("all-day");
  const [selectedCondition, setSelectedCondition] = useState("all");
  const [selectedSalesTypes, setSelectedSalesTypes] = useState([]); // ✅ Sales Type filter

  // ✅ Sidebar Categories
  const categories = [
    "Audi",
    "Bentley",
    "BMW",
    "Chevrolet",
    "Ferrari",
    "Ford",
    "Honda",
    "Hyundai",
    "Lamborghini",
    "Land Rover",
    "Lexus",
    "Mercedes",
    "Nissan Rogue",
    "Tesla",
    "Toyota Camry",
  ];

  // ✅ Sales Types
  const salesTypes = [
    "Upcoming",
    "Latest",
    "Highest Bidding",
    "Live Auction",
    "Popular",
  ];

  // ✅ Category change
  const handleCategoryChange = (category) => {
    if (selectedCategories.includes(category)) {
      setSelectedCategories(selectedCategories.filter((c) => c !== category));
    } else {
      setSelectedCategories([...selectedCategories, category]);
    }
  };

  // ✅ Sales Type change
  const handleSalesTypeChange = (type) => {
    if (selectedSalesTypes.includes(type)) {
      setSelectedSalesTypes(selectedSalesTypes.filter((t) => t !== type));
    } else {
      setSelectedSalesTypes([...selectedSalesTypes, type]);
    }
  };

  // ✅ Helper for checking Period (Morning/Afternoon/Evening)
  const getPeriod = (date) => {
    const hour = new Date(date).getHours();
    if (hour >= 6 && hour < 12) return "morning";
    if (hour >= 12 && hour < 18) return "afternoon";
    if (hour >= 18 && hour < 24) return "evening";
    return "all-day";
  };

  // ✅ Filtered Data
  const filteredCards = cardData.filter((card) => {
    // Category filter
    const matchCategory =
      selectedCategories.length === 0 ||
      selectedCategories.includes(card.category);

    // Search filter
    const matchSearch = card.title
      .toLowerCase()
      .includes(searchTerm.toLowerCase());

    // Period filter
    const cardPeriod = getPeriod(card.endDate);
    const matchPeriod =
      selectedPeriod === "all-day" || selectedPeriod === cardPeriod;

    // Condition filter (status field from fake-data)
    const matchCondition =
      selectedCondition === "all" ||
      card.status.toLowerCase() === selectedCondition.toLowerCase();

    // ✅ Sales Type filter
    let matchSalesType = true;
    if (selectedSalesTypes.length > 0) {
      if (selectedSalesTypes.includes("Upcoming")) {
        matchSalesType = card.status.toLowerCase() === "upcoming";
      }
      if (selectedSalesTypes.includes("Live Auction")) {
        matchSalesType = new Date(card.endDate) <= new Date(); // agar time khatam ho gaya => Live
      }
      if (selectedSalesTypes.includes("Latest")) {
        matchSalesType = true; // yaha ap logic laga sakte ho jaise "newest cards"
      }
      if (selectedSalesTypes.includes("Highest Bidding")) {
        matchSalesType = true; // yaha ap sort ya filter kar sakte ho
      }
      if (selectedSalesTypes.includes("Popular")) {
        matchSalesType = true; // dummy filter abhi ke liye
      }
    }

    return (
      matchCategory &&
      matchSearch &&
      matchPeriod &&
      matchCondition &&
      matchSalesType
    );
  });

  return (
    <div>
      <Header />

      <Banner
        title="Auction"
        bgImage={IMAGES.Auction_bg}
        breadcrumbs={["Auction"]}
      />

      <section className="auction-sec-01">
        <div className="container">
          <div className="row">
            {/* ✅ Left Sidebar */}
            <div className="col-md-3">
              <div className="product-left-box">
                {/* Search */}
                <div className="product-search">
                  <form onSubmit={(e) => e.preventDefault()}>
                    <input
                      type="search"
                      placeholder="Search"
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                    />
                    <button type="submit">
                      <IoSearchOutline />
                    </button>
                  </form>
                </div>

                {/* Categories */}
                <div className="product-category-checkbox">
                  <h4>Category</h4>
                  {categories.map((cat, i) => (
                    <div className="check-box" key={i}>
                      <input
                        type="checkbox"
                        id={cat}
                        checked={selectedCategories.includes(cat)}
                        onChange={() => handleCategoryChange(cat)}
                      />
                      <label htmlFor={cat}>{cat}</label>
                    </div>
                  ))}
                </div>

                {/* Period & Condition */}
                <div className="period-condition-select">
                  <div className="select-box">
                    <label htmlFor="period">Period</label>
                    <select
                      id="period"
                      name="period"
                      value={selectedPeriod}
                      onChange={(e) => setSelectedPeriod(e.target.value)}
                    >
                      <option value="all-day">All Day</option>
                      <option value="morning">Morning</option>
                      <option value="afternoon">Afternoon</option>
                      <option value="evening">Evening</option>
                    </select>
                  </div>

                  <div className="select-box">
                    <label htmlFor="condition">Condition</label>
                    <select
                      id="condition"
                      name="condition"
                      value={selectedCondition}
                      onChange={(e) => setSelectedCondition(e.target.value)}
                    >
                      <option value="all">All</option>
                      <option value="upcoming">Upcoming</option>
                      <option value="expired">Expired</option>
                    </select>
                  </div>
                </div>

                {/* ✅ Type of Sales */}
                <div className="types-of-sales product-category-checkbox">
                  <h4>Type Of Sales</h4>
                  {salesTypes.map((type, i) => (
                    <div className="check-box" key={i}>
                      <input
                        type="checkbox"
                        id={type}
                        checked={selectedSalesTypes.includes(type)}
                        onChange={() => handleSalesTypeChange(type)}
                      />
                      <label htmlFor={type}>{type}</label>
                    </div>
                  ))}
                </div>

                <div className="upcoming-auction popular-auction">
                  <div className="vertical-align-box">
                    <div className="text">
                      <h6>
                        Highest <span>Bidding.</span>
                      </h6>
                    </div>
                    <div className="row">
                      {cardData.slice(0, 3).map((val) => (
                        <div className="col-md-12 mb-12" key={val.id}>
                          <AuctionSlider item={val} />
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* ✅ Right Grid */}
            <div className="col-md-9">
              <div className="row">
                <div className="product-top-filter">
                  <div className="how-many-product">
                    <p>showing 1-12 of 26 results</p>
                  </div>
                  <div className="right-box">
                    <div className="filter-btn">
                      <ul>
                        <li>
                          <a href="/">
                            <TbFilterDown /> Filters
                          </a>
                        </li>
                      </ul>
                    </div>
                    <div className="default-sorting-selector">
                      <select name="sort" id="sort">
                        <option value="default">Default sorting</option>
                        <option value="az">Sort by A-Z</option>
                        <option value="za">Sort by Z-A</option>
                        <option value="low-high">
                          Sort by Price: Low to High
                        </option>
                        <option value="high-low">
                          Sort by Price: High to Low
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
                {filteredCards.length > 0 ? (
                  filteredCards.map((item) => (
                    <div className="col-md-4 mb-4" key={item.id}>
                      <AuctionSlider item={item} />
                    </div>
                  ))
                ) : (
                  <p>No products found</p>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Auction;
